import React, { useMemo } from "react";
import PropTypes from "prop-types";

import Filter from "../../../Filter";

const ApplicantEvaluationsFilters = ({
  copy,
  search,
  filters,
  zoneOptions,
  roleOptions,
  statusOptions,
  renderActionBeforeFilterToggle,
  onSearchChange,
  onFilterChange,
}) => {
  const filterItems = useMemo(
    () => [
      {
        type: "filter",
        name: "zone",
        placeholder: copy.filterZone,
        value: filters.zone,
        options: zoneOptions,
        onChange: (value) => onFilterChange("zone", value),
      },
      {
        type: "filter",
        name: "role",
        placeholder: copy.filterRole,
        value: filters.role,
        options: roleOptions,
        onChange: (value) => onFilterChange("role", value),
      },
      {
        type: "filter",
        name: "status",
        placeholder: copy.filterStatus,
        value: filters.status,
        options: statusOptions,
        onChange: (value) => onFilterChange("status", value),
      },
    ],
    [copy, filters, zoneOptions, roleOptions, statusOptions, onFilterChange],
  );

  return (
    <Filter
      searchInput={{
        placeholder: copy.searchPlaceholder,
        name: "search",
        value: search,
        onChange: onSearchChange,
      }}
      renderActionBeforeFilterToggle={renderActionBeforeFilterToggle}
      filters={filterItems}
    />
  );
};

ApplicantEvaluationsFilters.propTypes = {
  copy: PropTypes.shape({
    searchPlaceholder: PropTypes.string.isRequired,
    filterZone: PropTypes.string.isRequired,
    filterRole: PropTypes.string.isRequired,
    filterStatus: PropTypes.string.isRequired,
  }).isRequired,
  search: PropTypes.string.isRequired,
  filters: PropTypes.shape({
    zone: PropTypes.object,
    role: PropTypes.object,
    status: PropTypes.object,
  }).isRequired,
  zoneOptions: PropTypes.arrayOf(PropTypes.object).isRequired,
  roleOptions: PropTypes.arrayOf(PropTypes.object).isRequired,
  statusOptions: PropTypes.arrayOf(PropTypes.object).isRequired,
  renderActionBeforeFilterToggle: PropTypes.node,
  onSearchChange: PropTypes.func.isRequired,
  onFilterChange: PropTypes.func.isRequired,
};

ApplicantEvaluationsFilters.defaultProps = {
  renderActionBeforeFilterToggle: null,
};

export default ApplicantEvaluationsFilters;
